import { render, staticRenderFns } from "./Organisations.vue?vue&type=template&id=20ae269c&scoped=true"
import script from "./Organisations.vue?vue&type=script&lang=js"
export * from "./Organisations.vue?vue&type=script&lang=js"
import style0 from "./Organisations.vue?vue&type=style&index=0&id=20ae269c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ae269c",
  null
  
)

export default component.exports